/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ReportLink from 'components/ReportsModule/components/common/ReportLink';
import ReportCard from 'components/ReportsModule/components/common/ReportCard';
import LwtTable, { ColumnProps } from 'components/@common/Table/LwtTable';
import { KeyOrganizationEngagementReportResult } from 'types/schema-generated-types';
import { ReportEntityType } from '../../../../types';
import { TFunction } from 'i18next';

const getColumns: (t: TFunction) => ColumnProps<any>[] = (t: TFunction) => [
  {
    id: 'name',
    label: t('School'),
    sortKey: 'organization.name',
    getValue: item => (
      <ReportLink
        key={item.organization.id}
        entityType={ReportEntityType.SCHOOL}
        entityId={item.organization?.id}
      >
        {item.organization.name}
      </ReportLink>
    ),
    sortable: true
  },
  {
    id: 'totalStudentCount',
    label: t('Total Licensed Students'),
    helpText: t('totalStudents', { ns: 'ReportsHelpTableColumns' }),
    sortKey: 'totalStudentCount',
    getValue: item => <Typography>{item.totalStudentCount}</Typography>,
    sortable: true
  },
  {
    id: 'activeStudentCount',
    label: t('Active Students'),
    helpText: t('activeStudents', { ns: 'ReportsHelpTableColumns' }),
    sortKey: 'activeStudentCount',
    getValue: item => <Typography>{item.activeStudentCount}</Typography>,
    sortable: true
  },
  {
    id: 'curriculumProgressPercentage',
    label: t('Overall Curriculum Progress'),
    helpText: t('curriculumProgress', { ns: 'ReportsHelpCommon' }),
    sortKey: 'curriculumProgressPercentage',
    getValue: item => <Typography>{item.curriculumProgressPercentage}%</Typography>,
    sortable: true
  },
  {
    id: 'activitiesCompleted',
    label: t('Activities Completed'),
    helpText: t('activitiesCompleted', { ns: 'ReportsHelpCommon' }),
    sortKey: 'totalActivitiesCompletedCount',
    getValue: item => <Typography>{item.totalActivitiesCompletedCount}</Typography>,
    sortable: true
  },
  {
    id: 'averageWeeklyMinutesSpent',
    label: t('Average Weekly Minutes Spent'),
    helpText: t('averageWeeklyTimeSpent', { ns: 'ReportsHelpCommon' }),
    sortKey: 'averageWeeklyMinutesSpent',
    getValue: item => <Typography>{item.averageWeeklyMinutesSpent} minutes</Typography>
  }
];

const EngagementTableView: React.FC<{
  reportData: KeyOrganizationEngagementReportResult[];
  loading: boolean;
}> = ({ reportData, loading }) => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCommon', 'ReportsHelpTableColumns']);
  const columns = getColumns(t);

  return (
    <ReportCard title={t('Overview')} loading={loading} reportData={reportData}>
      <LwtTable columns={columns} data={reportData} />
    </ReportCard>
  );
};

export default EngagementTableView;
